import Vue from "vue";
import Vuex from "vuex";

//store
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    members: [],
    cat: "",
    sort: "true",
    tag: [],
    selectTag: [],
    isLoadCategoryDataTimes: 0,
    osakaMembers: [],
    hokkaidoMembers: [],
    tokyoMembers: [],
    gunmaMembers: [],
    hyogoMembers: [],
    fukuokaMembers: [],
    kagoshimaMembers: [],
    shizuokaMembers: [],
  },
  getters: {
    isLoadCategoryData(state) {
      return state.isLoadCategoryDataTimes;
    }
  },
  mutations: {
    setCity(state, member) {
      member.filter((i) => {
        if (i.area == "大阪") {
          state.osakaMembers.push(i);
        }
        if (i.area == "東京") {
          state.tokyoMembers.push(i);
        }
        if (i.area == "北海道") {
          state.hokkaidoMembers.push(i);
        }
        if (i.area == "兵庫") {
          state.hyogoMembers.push(i);
        }
        if (i.area == "群馬") {
          state.gunmaMembers.push(i);
        }
        if (i.area == "福岡") {
          state.fukuokaMembers.push(i);
        }
        if (i.area == "静岡") {
          state.shizuokaMembers.push(i);
        }
        if (i.area == "鹿児島") {
          state.kagoshimaMembers.push(i);
        }
      });
    },
    setMembers(state, member) {
      state.members = member;

      var tagAll = [];
      state.members.forEach(member => {
        if (state.cat == "") {
          tagAll.push(member.job);
        }
      });

      state.tag = [...new Set(tagAll)];

      state.isLoadCategoryDataTimes++;
    },
    searchCategory(state, cat) {
      state.cat = cat;

      var tagAll = [];
      state.members.forEach(member => {
        if (state.cat == "All") {
          tagAll.push(member.job);
        }
        if (member.business == cat) {
          tagAll.push(member.job);
        }
      });
      state.tag = [...new Set(tagAll)];

      state.isLoadCategoryDataTimes++;
    },
    sort(state, sort) {
      state.sort = sort;
    },
    sTag(state, tag) {
      const test = state.selectTag.filter(item => item == tag);
      if (test == "") {
        state.selectTag.push(tag);
      } else {
        const test2 = state.selectTag.indexOf(tag);
        state.selectTag.splice(test2, 1);
      }
    },
    resetTag(state) {
      state.selectTag = [];
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js